function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.289 15.596h34.7c1.356.282.675 1.886.84 2.839v35.021c-.297 1.287-1.987.64-2.992.798H10.29c-1.356-.283-.674-1.886-.84-2.84v-35.02c-.012-.428.39-.81.84-.798z",
  strokeLinecap: "square",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.414 47.051c1.75-.003 2.204-.978 2.217-2.711-.03-7.104.06-14.514-.045-21.615-.256-1.788-4.344-2.232-4.389.538.03 7.43.012 14.456.045 21.994.004.873.423 1.797 2.172 1.794z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.636.81c-3.359-.174-5.784 4.37-4.128 7.622.08.651-1.609.14-2.271.302H7.997c-1.13.3-1.04 2.646-.308 3.367 4.217.161 8.46.024 12.687.07H47.28c1.13-.3 1.04-2.646.308-3.367-4.217-.161-8.46-.024-12.687-.07h-3.283C33.515 5.41 31.188.7 27.636.81z",
  strokeLinecap: "square",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.414 47.051c1.75-.003 2.204-.978 2.217-2.711-.03-7.104.06-14.514-.045-21.615-.256-1.788-4.344-2.232-4.389.538.03 7.43.012 14.456.045 21.994.004.873.423 1.797 2.172 1.794zM37.414 47.051c1.75-.003 2.204-.978 2.217-2.711-.03-7.104.06-14.514-.045-21.615-.256-1.788-4.344-2.232-4.389.538.03 7.43.012 14.456.045 21.994.004.873.423 1.797 2.172 1.794z"
}));

var SvgTrashcan = function SvgTrashcan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrashcan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Trash can.fb514b59.svg";
export { ForwardRef as ReactComponent };